import { useEffect } from "react";

interface LightboxProps {
  url: string;
  onClose: () => void;
}

const Lightbox: React.FC<LightboxProps> = ({ url, onClose }) => {
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [onClose]);

  return (
    <button type="button" className="lightbox open" aria-label="Close preview" onClick={onClose}>
      <img src={url} alt="Full size preview" />
    </button>
  );
};

export default Lightbox;
